export const FETCH_PROFILE_DATA = 'FETCH_PROFILE_DATA';
export const FETCH_PROFILE = 'FETCH_PROFILE';
export const PROFILE_LOADING = 'PROFILE_LOADING';
